/**
 * Kreira debounced funkciju koja odlaže izvršavanje funkcije
 * dok ne protekne određeni vremenski period bez novih poziva
 * @param func Funkcija koju treba debounce-ovati
 * @param wait Vreme čekanja u milisekundama
 * @returns Debounced funkcija sa cancel metodom
 */
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) & { cancel: () => void } {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  function debouncedFunction(...args: Parameters<T>): void {
    const later = () => {
      timeout = null;
      func(...args);
    };

    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(later, wait);
  }

  // Add a cancel method to the function
  debouncedFunction.cancel = () => {
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debouncedFunction;
}
